import React from "react";
import { motion } from "framer-motion";
import { Zap, Users, Briefcase, ArrowRight } from "lucide-react";
import { useLang } from "@/lib/lang";
import { fadeUp, stagger } from "./constants";

/**
 * Transfer vehicles grid — one card per category (executive, van, SUV, luxury…).
 */
export default function FleetSection({ fleet, onBook }) {
  const { t } = useLang();
  return (
    <motion.section
      id="transfers"
      className="dt-section dt-section--alt"
      data-testid="transfers-section"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.1 }}
      variants={stagger}
    >
      <div className="dt-section__wrap">
        <motion.p className="dt-section__eyebrow" variants={fadeUp}>{t("landing_fleet_eyebrow")}</motion.p>
        <motion.h2 className="dt-section__title" variants={fadeUp}>{t("landing_fleet_title")}</motion.h2>
        <motion.p className="dt-section__desc" variants={fadeUp}>{t("landing_fleet_desc")}</motion.p>
        <motion.div className="dt-grid" variants={stagger}>
          {fleet.map((c) => {
            const sv = c.sample_vehicle;
            const photo = (sv && sv.photo) || c.image_url || `/images/vehicle-${c.key}.png`;
            const isElectric = sv && sv.fuel_type === "electric";
            return (
              <motion.article
                key={c.key}
                className="dt-vehicle"
                data-testid={`vehicle-card-${c.key}`}
                variants={fadeUp}
              >
                <div className="dt-vehicle__imgwrap">
                  <img src={photo} alt={c.label} className="dt-vehicle__img" loading="lazy" />
                  {isElectric && (
                    <span className="dt-vehicle__badge" data-testid={`electric-badge-${c.key}`}>
                      <Zap size={11} /> {t("landing_vehicle_electric_badge")}
                    </span>
                  )}
                </div>
                <div className="dt-vehicle__body">
                  <div className="dt-vehicle__label">{t("landing_vehicle_category")}</div>
                  <div className="dt-vehicle__name">{c.label}</div>
                  <div className="dt-vehicle__specs">
                    <span><Users size={12} /> {c.capacity_passengers || (sv && sv.capacity_passengers) || "1-4"} {t("landing_vehicle_pax")}</span>
                    <span><Briefcase size={12} /> {c.capacity_bags || (sv && sv.capacity_luggage) || 3} {t("landing_vehicle_bags")}</span>
                  </div>
                  {c.price_from_eur && (
                    <div className="dt-vehicle__price">
                      €{Math.round(c.price_from_eur)}<small>{t("landing_tour_from")}</small>
                    </div>
                  )}
                  <button
                    type="button"
                    className="dt-vehicle__cta"
                    onClick={() => onBook(c.key)}
                    data-testid={`vehicle-book-${c.key}`}
                  >
                    {t("landing_tour_book")} <ArrowRight size={12} />
                  </button>
                </div>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </motion.section>
  );
}
